// Apartment / floor / unit text typed into the address box ("44 Pierce St
// Second floor", "770 Eastern Pkwy Apt 4C", "12 Main St, Rear") belongs in
// Unit/Apt, not in the address. splitUnit takes it off the END of the address
// (or a whole ", Apt 3B" part) and hands it back separately.
//
// The SAME rules as the backend's routes/geocoding.py strip_unit() — keep the
// two in step. Street names that START with these words (Front St, Lower Main
// St, Suite Rd, Unit Ave) are left alone: a unit needs a number or a single
// letter after it, and a floor word only counts at the end.

const UNIT_WORDS = "apt|apartment|unit|suite|ste|rm|room|bldg|building|lot|trlr|trailer|dept|box";
const FLOOR_ORD = "\\d+(?:st|nd|rd|th)?|first|second|third|fourth|fifth|sixth|top|ground|main|upper|lower|bottom";
const UNIT_ID = "(?:[A-Za-z]?\\d[\\w-]*|[A-Za-z])";

const TAILS = [
  new RegExp(`\\s*#\\s*${UNIT_ID}\\s*$`),                                         // "#3B"
  new RegExp(`\\s+(?:${UNIT_WORDS})\\.?\\s*#?\\s*${UNIT_ID}\\s*$`, "i"),           // "Apt 3B", "Suite 200"
  new RegExp(`\\s+(?:${FLOOR_ORD})\\s+(?:fl|flr|floor)\\.?\\s*$`, "i"),            // "Second floor", "2nd fl"
  /\s+(?:fl|flr|floor)\.?\s*#?\s*\d+\w*\s*$/i,                                    // "Floor 2"
  /\s+(?:rear|basement|bsmt|upstairs|downstairs)\s*$/i,                           // "Rear"
];
const WHOLE_PART = new RegExp(
  `^(?:#\\s*${UNIT_ID}|(?:${UNIT_WORDS})\\.?\\s*#?\\s*${UNIT_ID}|(?:${FLOOR_ORD})\\s+(?:fl|flr|floor)\\.?|` +
  `(?:fl|flr|floor)\\.?\\s*#?\\s*\\d+\\w*|rear|basement|bsmt|upstairs|downstairs)$`, "i");

/** "44 Pierce St Second floor" -> { address: "44 Pierce St", unit: "Second floor" }.
 *  Nothing to take off -> { address: <as typed>, unit: "" }. */
export function splitUnit(value) {
  const original = String(value || "");
  const parts = [];
  const units = [];
  for (const part of original.split(",")) {
    let p = part.trim();
    if (!p) continue;
    if (parts.length && WHOLE_PART.test(p)) { units.push(p); continue; }   // ", Apt 3B,"
    const taken = [];
    for (;;) {
      let q = p;
      for (const rx of TAILS) {
        const m = q.match(rx);
        if (m && m.index > 0) { taken.unshift(m[0].trim()); q = q.slice(0, m.index).trim(); }
      }
      if (q === p || !q) break;
      p = q;
    }
    units.push(...taken);
    parts.push(p);
  }
  const unit = units.join(" ").trim();
  if (!unit || !parts.length) return { address: original, unit: "" };
  return { address: parts.join(", "), unit };
}
